/**
* Two Column Scroll JS
* -----------------------------------------------------------------------------
*
* All the JS for the Two Column Scroll component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

import {gsap} from 'gsap';
import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
import {CustomEase} from 'gsap/CustomEase.js';
gsap.registerPlugin( ScrollTrigger );
gsap.registerPlugin( CustomEase );
( function( app ) {
  const COMPONENT = {

    className: 'two-column-scroll',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      $( '.two-column-scroll' ).each( function() {
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: this,
            start: 'top 75%',
            scrub: 0.15,
            // markers: true,
            onRefresh: ( self ) => {
              if ( self.progress > 0 ) {
                $( this ).addClass( 'is-loaded' );
              }
            },
            onEnter: ( {progress, direction, isActive} ) => $( this ).addClass( 'is-active' ),
          },
        } );
      } );

      $( '.two-column-scroll' ).each( function( key, component ) {
        // get nav heights and whatnot
        const docStyle = getComputedStyle( document.documentElement );
        const navHeight = docStyle.getPropertyValue( '--navbarHeight' );
        const adminbarHeight = docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ).length > 0 ? docStyle.getPropertyValue( '--wp-admin--admin-bar--height' ) : 0;
        const topOffset = parseInt( navHeight ) + parseInt( adminbarHeight );
        // -------

        // set up some variables
        const speed = 2; // higher is slower

        const mediaQuery = window.matchMedia( '(min-width: 1024px)' );
        // Check if the media query is true
        if ( mediaQuery.matches ) {
          $( component ).height( $( component ).find( '.two-column-scroll__container' ).height() * speed );
        }

        $( document ).on( 'updateMediaQuery', ( event ) => {
          const mediaQuery = window.matchMedia( '(min-width: 1024px)' );
          // Check if the media query is true
          if ( mediaQuery.matches ) {
            $( component ).height( $( component ).find( '.two-column-scroll__container' ).height() * speed );
          }
        } );

        // pin the component
        const tl = gsap.timeline( {
          scrollTrigger: {
            trigger: component,
            pin: $( component ).find( '.two-column-scroll__container' )[0],
            start: 'top ' + topOffset,
            end: 'bottom bottom',
            scrub: 0,
          },
        } );

        tl.to( '.two-column-scroll__container', {height: '100%', duration: 4000} )
            .to( '.two-column-scroll__container .two-column-scroll__heading', {opacity: 1, translateY: '0', duration: 1000} )
            .to( '.two-column-scroll__container .two-column-scroll__buttons', {opacity: 1, translateY: '0', duration: 1000} )
            .to( '.two-column-scroll__container .two-column-scroll__col', {opacity: 1, translateY: '0', duration: 1000} );
      } );
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'two-column-scroll', COMPONENT );
} )( app );
